import styled from "styled-components/macro";
import { typography } from "src/utils/styledComponents/typography";

/**
 * The withdraw form's column.
 *
 * It was 57% of whatever contained it, 90% below the largest breakpoint, and
 * centred — so the form's width was a fraction of the window rather than a
 * measure chosen for a form, and inside a dialog it left the footer band and
 * the fields short of the dialog's own edges. Full width now: the page caps
 * the measure at the form column inside it, and a dialog is already the right
 * width.
 */
export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  ${typography.CustomText("1em")}
`;
